<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="ctag1"><i>To my mentor and friend, Professor C. Wickham Skinner,<br/> who taught me that great teaching comes from<br/> preparing thoroughly, challenging the students,<br/> listening carefully and respectfully,<br/> constantly learning as you teach,<br/> and including in every class<br/> a clear, insightful, new concept.</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// simm_9781118040522_oeb_ded_r1.vue?23438bc0